import { Box } from "@mui/material";
import { AcxExpandableText } from "components/UI/AcxExpandableText";
import Markdown from "markdown-to-jsx";
import React from "react";

interface LLMReasoningProps {
    reasoning?: string | null;
    /**
     * The step name the reasoning came from
     * @optional
     */
    fromStep?: string;
}

export function LLMReasoning({ reasoning, fromStep }: LLMReasoningProps) {
    const reasoningString = fromStep
        ? `Reasoning (from step ${fromStep}):`
        : "Reasoning:";

    return (
        <AcxExpandableText>
            <Box fontWeight="bold" component="span">
                {reasoningString}
            </Box>{" "}
            <Markdown>{!!reasoning ? reasoning : "None given"}</Markdown>
        </AcxExpandableText>
    );
}
